const dot = (color: string): React.CSSProperties => ({
  width: 6, height: 6, borderRadius: '50%', background: color, opacity: 0.7,
});

const miniCard: React.CSSProperties = {
  background: '#0c1520',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: '0.5rem',
  padding: '0.5rem 0.625rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
};

const miniHeader: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.3rem',
  fontSize: '0.5rem',
  fontWeight: 700,
  color: '#9ca3af',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
};

const cards = [
  { label: 'Metrics', color: '#3b82f6', desc: 'Payoff, Sharpe, profit factor' },
  { label: 'Behaviour', color: '#f59e0b', desc: 'Strategy profile classification' },
  { label: 'Trade Structure', color: '#22c55e', desc: 'Win/loss distribution' },
  { label: 'Exposure', color: '#06b6d4', desc: 'Time in market, duration' },
  { label: 'Regimes', color: '#10b981', desc: 'Volatility and trend mix' },
  { label: 'Drawdown', color: '#ef4444', desc: 'Depth, duration, recovery' },
  { label: 'DD Envelope', color: '#f97316', desc: 'Monte Carlo simulation' },
  { label: 'Parameters', color: '#8b5cf6', desc: 'Config and validation stage' },
];

export default function ResultsDashboardOverviewMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header" style={{ justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <span style={{ color: '#f97316', fontSize: '0.625rem' }}>BACKTEST</span>
          <span style={{ color: '#9ca3af', fontSize: '0.625rem' }}>Results Dashboard Overview</span>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', fontSize: '0.5625rem', color: '#9ca3af' }}>
          {['Results', 'Trades', 'Trace', 'Monte Carlo', 'Editor'].map((tab, i) => (
            <span key={tab} style={i === 0 ? { color: '#e5e7eb', fontWeight: 700 } : undefined}>{tab}</span>
          ))}
        </div>
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
          {cards.map((c) => (
            <div key={c.label} style={miniCard}>
              <div style={miniHeader}><span style={dot(c.color)} /> {c.label}</div>
              <div style={{ fontSize: '0.5625rem', color: '#6b7280', lineHeight: 1.4 }}>{c.desc}</div>
            </div>
          ))}
        </div>
        <div style={{
          marginTop: '0.625rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          background: '#0c1520',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '0.5rem',
          padding: '0.5rem 0.625rem',
        }}>
          <div style={{
            width: 22, height: 22, borderRadius: '50%',
            border: '2px solid #f59e0b', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            fontSize: '0.5625rem', fontWeight: 700, color: '#f59e0b',
          }}>C</div>
          <div>
            <span style={{ fontSize: '0.625rem', fontWeight: 700, color: '#e5e7eb' }}>60/100</span>
            <span style={{ fontSize: '0.5rem', color: '#9ca3af', marginLeft: 6 }}>Viability Score — Profitability + Risk + Consistency + Robustness</span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        Eight analysis cards plus a composite viability score — each answering a different question about strategy performance.
      </div>
    </div>
  );
}
